import allNowLogo from 'assets/images/driver-portal/all-now-logo.svg';
import { Col, Row } from 'components';
import { theme } from 'configs/styled';
import { useQueryParams } from 'hooks';
import React from 'react';
import { ImageLogo } from './HeaderPortal.style';

export interface IHeaderPortal {}

const HeaderPortal: React.FC<IHeaderPortal> = props => {
  const { children } = props;
  const { search, pushUrl } = useQueryParams();

  const goToMainPage = () => {
    pushUrl('/', search);
  };

  return (
    <Row
      justify="start"
      align="middle"
      style={{
        height: theme.elementSize.navbarDriverPortalHeight,
      }}
    >
      <Col xs={0} sm={0} md={6} lg={7} xl={8} xxl={9} />
      <Col xs={24} sm={24} md={12} lg={10} xl={8} xxl={6}>
        <div
          style={{
            display: 'flex',
            padding: `0 ${theme.spacing.xs}`,
            justifyContent: 'space-between',
          }}
        >
          <ImageLogo
            style={{ marginRight: theme.spacing.xs, cursor: 'pointer' }}
            src={allNowLogo}
            onClick={goToMainPage}
          />
          {children}
        </div>
      </Col>
      <Col xs={0} sm={0} md={6} lg={7} xl={8} xxl={9} />
    </Row>
  );
};

export default HeaderPortal;
